module.exports = __webpack_public_path__ + "static/media/villanas-reactcionarias.6f243b49.png";